/* eslint-disable no-alert */
import React from 'react'
import {
  Grid,
  Segment,
  Header,
  Button,
  Icon,
  Card,
  List,
  Label,
  Divider
} from 'semantic-ui-react'

import { connect } from 'react-redux'
import { size, map, capitalize, without } from 'lodash'
import moment from 'moment'
import firebase from '../../config/firebase'
import ServiceAvailabilityForm from './components/ServiceAvailabilityForm'

import RegionActions from '../../reducers/regionReducer'
import ServiceAvailabilityActions from '../../reducers/serviceAvailabilityReducer'

const styles = {
  header: {
    margin: 10,
    display: 'inline-block',
  },
  addBtn: {
    margin: 10
  },
  listContentWrapper: {
    padding: '3px 0px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
}

const Row = ({ field, value, labelColor, tag }) => {
  return (
    <List.Item>
      <List.Content style={styles.listContentWrapper}>
        <div style={{ display: 'flex', flex: 1 }}>
          {field}
        </div>
        <div style={{ display: 'flex' }}>
          <Label size="small" color={labelColor} tag={tag}>
            {value}
          </Label>
        </div>
      </List.Content>
    </List.Item>
  )
}

class ServiceAvailability extends React.Component {
  state = {
    formVisible: false,
    action: null,
    zoneData: null,
  }

  componentDidMount() {
    const { getDistricts, getServiceAvailability, region } = this.props

    getDistricts({ region })
    getServiceAvailability()
  }

  onAddClick = () => {
    this.setState({ formVisible: true, action: 'new' })
  }

  onEditClick = (data) => {
    this.setState({
      zoneData: data,
      formVisible: true,
      action: 'edit'
    })
  }

  onDeleteClick = async id => {
    try {
      const { removeSingleZone } = this.props
      const collection = firebase.firestore().collection('service_availability')

      await collection.doc(id).delete()

      removeSingleZone({ id })
    } catch (error) {
      alert('Failed to delete this service availability')
    }
  }

  convertTime = time => {
    return moment(parseInt(time, 10)).format('HH:mm a')
  }

  renderServiceZone = (zone, key) => {
    const {
      ended_at: endTime,
      started_at: startTime,
      status,
      active
    } = zone

    const districtKeys = without(Object.keys(zone.zones), 'polygon')

    return (
      <Card key={key}>
        <Card.Content>
          <Card.Header>
            {capitalize(status)}
          </Card.Header>
          <Card.Description>
            <List divided verticalAlign='middle' style={{ marginTop: 10 }}>
              <Row field='Start Time' value={startTime} />
              <Row field='End Time' value={endTime} />
              <Row field='Status' value={active ? 'Active' : 'Inactive'} labelColor={active ? 'green' : 'red'} />
              <Row field='Districts' value={districtKeys.length} />
            </List>
          </Card.Description>
        </Card.Content>
        <Card.Content extra textAlign='right' >
          <Button
            color='black'
            size="tiny"
            content="Edit"
            onClick={() => this.onEditClick(zone)}
          />
          <Button
            color='red'
            size="tiny"
            content="Delete"
            onClick={() => this.onDeleteClick(key)}
          />
        </Card.Content>
      </Card>
    )
  }

  renderServiceZones = () => {
    const { serviceAvailability } = this.props

    return map(serviceAvailability, (zone, key) => this.renderServiceZone(zone, key))
  }

  renderNoResult = () => {
    return <Header textAlign='center' size="small" style={{ padding: 16 }}>No data available</Header>
  }


  render() {
    const { formVisible, action, zoneData } = this.state
    const { region, districts, loading, serviceAvailability, setSingleZone } = this.props

    return (
      <div>
        <Grid>
          <Grid.Column width="16">
            <Segment color="black" loading={loading}>
              <Header size="large" style={styles.header}>
                Service Availability
              </Header>
              <Button icon color="black" floated="right" onClick={this.onAddClick} style={styles.addBtn}>
                <Icon name="add" />
              </Button>

              <Divider style={{ margin: 10 }} />

              <div style={styles.optionsWrapper} className="hide-scrollbar">
                <Card.Group style={{ margin: 0 }}>
                  {size(serviceAvailability) > 0
                    ? this.renderServiceZones()
                    : this.renderNoResult()
                  }
                </Card.Group>
              </div>

            </Segment>
          </Grid.Column>
        </Grid>
        {formVisible ? (
          <ServiceAvailabilityForm
            visible={formVisible}
            districts={districts}
            action={action}
            region={region}
            setSingleZone={setSingleZone}
            serviceZone={zoneData}
            onClose={() => this.setState({ formVisible: false })}
          />
        ) : null}
      </div>
    )
  }
}

const mapState = ({ regions, serviceAvailability, auth }) => ({
  region: auth.data.region,
  districts: regions.pnh.districts,
  loading: regions.pnh.loading || serviceAvailability.loading,
  serviceAvailability: serviceAvailability.data,
})

const mapDispatch = {
  getDistricts: RegionActions.getDistricts,
  getServiceAvailability: ServiceAvailabilityActions.getServiceAvailability,
  setSingleZone: ServiceAvailabilityActions.setSingleServiceZone,
  removeSingleZone : ServiceAvailabilityActions.removeSingleServiceZone,
}

export default connect(mapState, mapDispatch)(ServiceAvailability)



// WEBPACK FOOTER //
// ./src/containers/serviceAvailability/index.js